import { produce } from "immer";
import { CptCodesTableRowModel } from "../../../../../data-model/cptCodesTableModel";
import { CptCodeWithDetailsKeys } from "../../../../../enums/tableColumnKeys";
import { checkIfJCodeFieldHasError } from "./computeErrorStates";
import { determineIfTheJCodeFieldShouldBeEditable } from "./determineIfTheFieldShouldBeEditable";

export const doModificationsRelatedToJCode = (
  rowDataToUpdate: CptCodesTableRowModel,
) => {
  const jCodesErrorState = checkIfJCodeFieldHasError(
    rowDataToUpdate[CptCodeWithDetailsKeys.PaRequired]?.currentStatusId,
    rowDataToUpdate[CptCodeWithDetailsKeys.JCodes]?.data ?? "",
  );
  const jCodeFieldShouldBeEditable = determineIfTheJCodeFieldShouldBeEditable(
    rowDataToUpdate[CptCodeWithDetailsKeys.PaRequired]?.currentStatusId,
    rowDataToUpdate[CptCodeWithDetailsKeys.JCodes]?.data ?? "",
  );

  return produce(rowDataToUpdate, (draft) => {
    if (draft[CptCodeWithDetailsKeys.JCodes]) {
      draft[CptCodeWithDetailsKeys.JCodes].hasError = jCodesErrorState;
      draft[CptCodeWithDetailsKeys.JCodes].allowInputModification =
        jCodeFieldShouldBeEditable;
    }
  });
};
